<template>
  <div>
    <FullCalendar  ref="calendar"   :options="calendarOptions"  style="font-size: 16px;margin-left: 10px;"  />
    <el-dialog
        title="给出可预约时间"
        :visible.sync="detailDialogShow"
        width="250px"
        :close-on-click-modal=false
    >
      <span style="color: #0dafe0; margin-bottom: 5px;display: block" >{{dateStr}}</span>
      <span><input type="checkbox" @click="isAll">&nbsp;&nbsp;&nbsp;全选</span>
      <el-checkbox-group v-model="checkList" >
        <el-checkbox v-for='rt in reserveTimeList' :label="rt.time" :disabled="rt.disabled"  style="display: block" @change="clickStatus(rt)"></el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer" >
        <el-button
            type="info"
            size="small"
            icon="el-icon-search"
            @click="dialogCancel"
        >取消</el-button>
        <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="saveReserve"
        >确定</el-button>
      </div>
    </el-dialog>
  
    <el-dialog
        title="预约详情"
        class="detailDialog"
        :visible.sync="reserveDetailDialog"
        width="450px"
        :before-close="chanelReserveDetailDialog"
        :close-on-click-modal=false
    >
      <el-form class="demo-ruleForm" align="left" label-width="100px" v-model="appointmentStudent">
        <el-form-item label="预约时间：" prop="userName">{{formatReserveDate(currentEvent.createTime)}} {{currentEvent.htime}}</el-form-item>
        <el-form-item label="学生姓名：" prop="studentName">{{appointmentStudent.studentNameView}}</el-form-item>
        <el-form-item label="所在时区：" prop="phone">{{appointmentStudent.studentTimeZone}}</el-form-item>
        <el-form-item label="学生账号：" prop="studentName">{{appointmentStudent.studentName}}</el-form-item>
        <el-form-item label="学生留言：" prop="studentMessage"></el-form-item>
        <div style="margin-left: 13px;">{{appointmentStudent.studentMessage}}</div>
        <el-button
            round
            type="success"
            size="small"
            style="height: 30px; width: 100px; margin-left: 10px; line-height: 0px; margin-top: 15px"
            @click="goto(currentEvent.meetingUrl)"
        >进入教室</el-button>
      </el-form><br>
      <el-form class="demo-ruleForm" ref="reserveForm" align="left" label-width="100px" :model="currentEvent">
        <el-form-item label="预约状态：" prop="status" >
          <!--<el-select v-model="appointmentStudent.status" size="small">-->
            <!--<el-option label="未开始" :value="4"></el-option>-->
            <!--<el-option label="已取消" :value="2"></el-option>-->
            <!--<el-option label="完成" :value="1"></el-option>-->
            <!--<el-option label="过期" :value="3"></el-option>-->
          <!--</el-select>-->
          <el-button type="text" disabled style="color: #606266" v-if="appointmentStudent.status == 4">未开始</el-button>
          
          <el-button type="text" disabled style="color: #606266" v-if="appointmentStudent.status == 3">已过期</el-button>
          <el-button type="text" v-if="appointmentStudent.status == 3" @click="finishReserve(2)">(取消)</el-button>
          <el-button type="text" disabled style="color: #606266" v-if="appointmentStudent.status == 2">已取消</el-button>
          <el-button type="text" disabled style="color: #606266" v-if="appointmentStudent.status == 1">已完成</el-button>
          <el-button type="text" @click="finishReserve(1)" v-if="appointmentStudent.status != 1 && appointmentStudent.status != 2">(完成)</el-button>
        </el-form-item>
        <el-form-item label="试讲教师：" prop="userName">{{currentEvent.managerName}}</el-form-item>
        <el-form-item label="教师留言：" prop="managerMessage">
        </el-form-item>
        <el-input
            type="textarea"
            :rows="3"
            style="margin-left: 12px"
            v-model="currentEvent.managerMessage"
            :disabled="oldStatus == 2"
            placeholder="教师留言"
            size="small"
        ></el-input>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
            round
            type="success"
            size="small"
            style="height: 30px; width: 100px; margin-left: 5px"
            @click="submitMessage"
        >提交</el-button>
        <el-button
            round
            type="info"
            size="small"
            style="height: 30px; width: 100px;"
            @click="chanelReserveDetailDialog"
        >取消</el-button>
      </div>
    </el-dialog>
  </div>
  
</template>
<script>
  import FullCalendar from '@fullcalendar/vue';
  import dayGridPlugin from '@fullcalendar/daygrid';
  import timeGridPlugin from '@fullcalendar/timegrid';
  import interactionPlugin from '@fullcalendar/interaction';
  import list from '@fullcalendar/list';
  import {dateFormat,compareDate,compareTime} from '@/api/utils.js';
  var reserveTimeTemp = [
    {time: '06:00', isSelect: false, disabled: false, title:''},
    {time: '06:30', isSelect: false, disabled: false, title:''},
    {time: '07:00', isSelect: false, disabled: false, title:''},
    {time: '07:30', isSelect: false, disabled: false, title:''},
    {time: '08:00', isSelect: false, disabled: false, title:''},
    {time: '08:30', isSelect: false, disabled: false, title:''},
    {time: '09:00', isSelect: false, disabled: false, title:''},
    {time: '09:30', isSelect: false, disabled: false, title:''},
    {time: '10:00', isSelect: false, disabled: false, title:''},
    {time: '10:30', isSelect: false, disabled: false, title:''},
    {time: '11:00', isSelect: false, disabled: false, title:''},
    {time: '13:00', isSelect: false, disabled: false, title:''},
    {time: '13:30', isSelect: false, disabled: false, title:''},
    {time: '14:00', isSelect: false, disabled: false, title:''},
    {time: '14:30', isSelect: false, disabled: false, title:''},
    {time: '15:00', isSelect: false, disabled: false, title:''},
    {time: '15:30', isSelect: false, disabled: false, title:''},
    {time: '16:00', isSelect: false, disabled: false, title:''},
    {time: '16:30', isSelect: false, disabled: false, title:''},
    {time: '17:00', isSelect: false, disabled: false, title:''},
    {time: '17:30', isSelect: false, disabled: false, title:''},
    {time: '18:00', isSelect: false, disabled: false, title:''},
    {time: '18:30', isSelect: false, disabled: false, title:''},
    {time: '19:00', isSelect: false, disabled: false, title:''},
    {time: '19:30', isSelect: false, disabled: false, title:''},
    {time: '20:00', isSelect: false, disabled: false, title:''},
    {time: '20:30', isSelect: false, disabled: false, title:''},
    {time: '21:00', isSelect: false, disabled: false, title:''},
    {time: '21:30', isSelect: false, disabled: false, title:''},
    {time: '22:00', isSelect: false, disabled: false, title:''},
  ];
  
  export default {
    name: '',
    components: {
      FullCalendar // make the <FullCalendar> tag available
    },
    data() {
      return {
        oldStatus: '',
        calendarApi: '',
        detailDialogShow: false,
        text: '',
        calendarEvents: '',
        reserveDetailDialog: false,
        dateStr: '',
        checkList: [],
        currentEvent: '',
        appointmentStudent: '',
        reserveTimeList: '',
        calendarOptions: {
          plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, list],
          initialView: 'dayGridMonth',
          weekMode: 'variable',
          events: this.getEvents,
          headerToolbar: {
            left: 'prev,next',
            center: 'title',
            right: 'today dayGridMonth,timeGridWeek,timeGridDay copyWeekBtn'
          },
        // 🔥 自定义按钮（加在这里）
          customButtons: {
            copyWeekBtn: {
              text: '复制本周时间到下周',
              click: this.copyWeekToNextWeek // 绑定方法
            }
          },
          // ======================
          // 🔥 关键：视图切换时显示/隐藏按钮
          // ======================
          viewDidMount: (info) => {
            const copyBtn = document.querySelector('.fc-copyWeekBtn-button')
            if (!copyBtn) return

            // 只有周视图才显示
            if (info.view.type === 'timeGridWeek') {
              copyBtn.style.display = 'inline-block'
            } else {
              copyBtn.style.display = 'none'
            }
          },
          dragScroll: false,
          buttonText: {
            today: '今天',
            month: '月视图',
            week: '周视图',
            day: '日视图',
            list: '列表'
          },
          locale: 'zh-cn',
          displayEventEnd: false , //所有视图显示结束时间 false // for dayGridMonth and dayGridWeek views true  // for timeGridWeek, timeGridDay, and dayGridDay
          dateClick: this.handleDateClick,
          eventClick: this.eventClick,
          prevClick: this.changeMonth,
          allowContextMenu: true,
          editable: true,
          selectable: true,
          selectMirror: true,
          dayMaxEvents: true,
          eventTimeFormat: { // like '14:30:00'
            hour: 'numeric',
            minute: 'numeric',
            meridiem: false,
            hour12: false //设置时间为24小时
          },
          slotLabelFormat: [
            {
              hour: 'numeric',
              minute: 'numeric',
              omitZeroMinute: false,
              hour12: false,
              meridiem: 'lang'
            }
          ],
          allDaySlot: false,
          slotLabelInterval: '00:30',//时间轴半个小时显示
          slotDuration:'00:30:00',//在agenda的视图中, 两个时间之间的间隔(分钟)
          slotMinTime : '08:00:00',//设置显示的时间从几点开始
          slotMaxTime:'23:00:00'//设置显示的时间从几点结束
        }
      };

    },
    methods: {
      initData(info,successCallback) {
      

      },
      isAll(){
        var isCheckAll = event.target.checked;
        let allReserveTimeList = JSON.parse(JSON.stringify(reserveTimeTemp));
        var dateStr = this.dateStr;
        for(var i = 0; i < allReserveTimeList.length; i++){
          let today = dateFormat(new Date());
          console.log(today.substr(0,16));
          let flag = compareTime(dateStr+' '+allReserveTimeList[i].time,today.substr(0,16));
          console.log(dateStr+' '+allReserveTimeList[i].time,flag);
          if(flag == 1) {
            if(isCheckAll==true){
              this.checkList.push(allReserveTimeList[i].time);
              allReserveTimeList[i].disabled = true;
            }else{
              this.checkList=[];
            }
          }else{
            allReserveTimeList[i].disabled = false;
          }
        }
      },


      getEvents(info, successCallback, failureCallback) {
        if(!info) {
          return;
        }
        let start = info.startStr.substring(0,10);
        let end = info.endStr.substring(0,10);
        let params = {
          createTimeStart: start,
          createTimeEnd: end
        };
        this.https.fetchPost('/appointmentManagerInfo/selectListByIsAppointment', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.calendarEvents = [];
            if(data.data.data) {
              for (let event of data.data.data) {
                let date = dateFormat(event.createTime).substr(0,10);
                let start = date+' '+ event.htime;
                let end = dateFormat(new Date(start).getTime()+3600*1000*0.5);
                let color = '#E6A23C'; // 未预约
                let title = "";
                if(event.isAppointment == 1) {
                  // studentNameView
                  for(let student of event.appointmentStudentInfoVoList) {
                    if(student.status != 2) {
                      title = "　"+student.studentNameView;
                    }
                  }
                  color = '#67C23A';  //已有预约
                }
                if(compareTime(dateFormat(new Date()),start) == 1) {
                  color = '#909399' // 过期
                }
                let e = {
                  start: start,
                  end: end,
                  data: event,
                  title: title,
                  color: color
                };
                this.calendarEvents.push(e);
              }
              console.log('单元格内容列表：',this.calendarEvents);
              successCallback(this.calendarEvents);
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch((err) => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      handleDateClick(val) {
        if(val.view.type == 'timeGridDay' || val.view.type == 'timeGridWeek') {
          return;
        }
        this.dateStr = val.dateStr;
        this.reserveTimeList = JSON.parse(JSON.stringify(reserveTimeTemp));
        this.checkList = [];
        let todayEvent = [];
        for(let event of this.calendarEvents) {
          let eventDay = event.start.substring(0,10);
          if(this.dateStr == eventDay) {
            todayEvent.push(event);
          }
        }
        let today = dateFormat(new Date());
        let flag = compareTime(today.substr(0,10),val.dateStr);
        console.log(flag);
        for(let time of this.reserveTimeList) {
          time.isAppointment = 0;
          for(let tdEvent of todayEvent) {
            if(time.time == tdEvent.start.substring(11)) {
              if(tdEvent.data.isAppointment == 1) {
                time.isAppointment = 1;
              }
              this.checkList.push(time.time);
            }
          }
          if(flag == 1) {
            time.disabled = true;
          }
          if(flag == -1) {
            time.disabled = false;
          }
          if(flag == 0) {
            let t = val.dateStr+" "+time.time;
            let h = 0; //设置提前多少小时不让预约
            let t_ = dateFormat(new Date().getTime()+3600*1000*h);
            console.log(t_);
            let flag_ = compareTime(t_, t);
            if(flag_ == 1) {
              time.disabled = true;
            }
            if(flag_ != 1) {
              time.disabled = false;
            }
          }
        }
        this.detailDialogShow = true;
      },
      changeMonth(start, end, current) {
        console.log('21');
      },
      dialogCancel() {
        this.detailDialogShow = false;
        this.reserveTimeList = JSON.parse(JSON.stringify(reserveTimeTemp));
        console.log(this.reserveTimeList);
      },
      eventClick(val) {
        // 状态 未开始 已完成 过期 取消
        let start = val.event.start;
        if(val.view.type == 'timeGridDay' || val.view.type == 'timeGridWeek') {
          let dateTime = dateFormat(start).substr(0,16);
          for(let event of this.calendarEvents) {
            if(event.start == dateTime) {
              this.currentEvent = event.data;
              for(let student of event.data.appointmentStudentInfoVoList) {
                if(student.status != 2) {
                  this.appointmentStudent = student;
                  this.oldStatus = student.status;
                }
              }
              
            }
          }
          if(this.currentEvent.isAppointment == 1) {
            this.reserveDetailDialog = true;
          }else {
            this.$message({
              type: 'info',
              message: '没有学生预约该时段！'
            })
          }
          return;
        }
        this.calendarApi.changeView('timeGridDay',start);
      },
      
      deleteEvents(day) {
        for(let i in this.calendarEvents) {
          let eventDay = this.calendarEvents[i].start.substring(0,10);
          if(day == eventDay) {
            this.calendarEvents.splice(i,1);
          }
        }
      },

      // 格式化日期为 yyyy-MM-dd HH:mm:ss
      formatDate(date) {
        const d = new Date(date)
        const year = d.getFullYear()
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      },

      // 复制本周所有时间段到下一周
      async copyWeekToNextWeek() {
        this.$confirm('确定复制该周时间段到下一周, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const calendarApi = this.$refs.calendar.getApi()
            const view = calendarApi.view

            // 1. 获取本周开始、结束时间（原生JS）
            const weekStart = view.currentStart
            const weekEnd = view.currentEnd
            console.log("当前周开始日期：",weekStart);
            console.log("当前周结束日期：",weekEnd);

            // 2. 获取当前周所有事件
            const weekEvents = calendarApi.getEvents().filter(ev => {
              const evStart = new Date(ev.start)
              return evStart > weekStart && evStart < weekEnd
            })

            console.log("当前周事件：",weekEvents);

            if (weekEvents.length === 0) {
              this.$message.warning('本周没有可复制的时间段')
              return
            }

              // 3. 每个事件 +7天（原生JS）
            const newEvents = weekEvents.map(ev => {
            const start = new Date(ev.start)
            const end = new Date(ev.end)

              // 加7天
            start.setDate(start.getDate() + 7)
            end.setDate(end.getDate() + 7)

            return {
                ...ev.extendedProps,
                title: ev.title,
                start: this.formatDate(start),
                end: this.formatDate(end),
                id: ev.id + '-copy-' + Date.now()
              }
            })

            // 4. 添加到日历
            newEvents.forEach(item => {
              console.log("item",item);
              var createTime = item.start;
              let timeList = [];
              timeList.push(item.data.htime);
              let params1 = {
                htime: item.data.htime,
                createTime: createTime
              };
              console.log('目标参数',params1)
              this.https.fetchPost('/appointmentManagerInfo/copyAppointmentByTimeList', params1, 'json').then((data) => {
                  let code = data.data.code;
                  let msg = data.data.msg;
                }).catch((err) => {
                  console.log(err);
                  this.$message.error('网络错误');
                });
              })

            this.$message.success(`复制成功！共复制 ${newEvents.length} 个时间段`)
            calendarApi.refetchEvents(); 

            // 跳转到下周
            calendarApi.next();
          }).catch(err=>{
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
        })
        
      },
      
      saveReserve() {
        let params = {
          timeList: this.checkList,
          createTime: this.dateStr
        };
        console.log("saveReserve",params);
        this.https.fetchPost('/appointmentManagerInfo/updateIsAppointmentByTimeList', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.deleteEvents(this.dateStr);
                for(let item of this.checkList) {
                  let start = this.dateStr+' '+ item;
                  let event = {
                    title: '',
                    start: start
                  };
                  this.calendarEvents.push(event);
                }
                this.calendarApi.refetchEvents();
                this.detailDialogShow = false;
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              } else {
                this.$message({
                  type: 'info',
                  message: '加载失败:' + msg
                });
              }
            }).catch((err) => {
              console.log(err);
              this.$message.error('网络错误');
            });
      
      },
      finishReserve(val) {
        this.appointmentStudent.status = val;
        /*let params = {
          appointmentManagerId: this.currentEvent.appointmentManagerId,
          appointmentStudentInfoVoList: {
            appointmentStudentId:this.appointmentStudent.appointmentStudentId,
            status: val,
          },
          managerMessage: this.currentEvent.managerMessage
        }
        this.https.fetchPost('/appointmentManagerInfo/updateAppointmentManagerInfoVoByAppointmentStudentId', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.$message({
              type: 'success',
              message: '提交成功！'
            });
            this.appointmentStudent.status = val;
            this.calendarApi.refetchEvents();
          } else {
            this.$message({
              type: 'info',
              message: '操作失败！'
            });
          }
        }).catch((err) => {
          console.log(err);
          this.$message.error('网络错误');
        });*/
      },
      chanelReserveDetailDialog() {
        this.appointmentStudent.status = this.oldStatus;
        this.reserveDetailDialog = false;
        this.$refs['reserveForm'].resetFields();
      },
      submitMessage() {
        if(this.currentEvent.managerMessage.length >50) {
          this.$message({
            type: 'info',
            message: '留言不能超过50个字！'
          });
          return;
        }
        let params = {
          appointmentManagerId: this.currentEvent.appointmentManagerId,
          appointmentStudentInfoVoList: {
            appointmentStudentId: this.appointmentStudent.appointmentStudentId,
            status: this.appointmentStudent.status,
          },
          managerMessage: this.currentEvent.managerMessage
        }
        this.https.fetchPost('/appointmentManagerInfo/updateAppointmentManagerInfoVoByAppointmentStudentId', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.$message({
              type: 'success',
              message: '提交成功！'
            });
            this.calendarApi.refetchEvents();
            this.reserveDetailDialog = false;
          } else {
            this.appointmentStudent.status = this.oldStatus;
            this.$message({
              type: 'info',
              message: '操作失败！'+msg
            });
          }
        }).catch((err) => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      
      formatReserveDate(val) {
        return dateFormat(new Date(val)).substr(0,10);
      },
      clickStatus(item) {
        console.log(item);
        if(item.isAppointment == 1) {
          this.$message({
            type: 'info',
            message: '此时间已有学生预约，不可修改！'
          });
          this.checkList.push(item.time);
        }
      },
      goto(url) {
        window.open(url);
      },
    },
    mounted () {
      this.calendarApi = this.$refs.calendar.getApi();
    },
    created: function() {
      this.initData();
    }
  };
</script>

<style >
  @import "~@fullcalendar/daygrid/main.css";
  @import "~@fullcalendar/timegrid/main.css";
  .el-dialog {
    border-radius:10px;
  }
  .demo-ruleForm > .el-form-item {
    margin-bottom: 0px;
  }
  .el-form-item__content {
    margin-left: 0px;
  }

  .el-dialog__body {
    padding: 5px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
  .fc-timegrid-event-condensed .fc-event-time:after {
    content: ''
  }
  .detailDialog .el-form-item__label {
    font-weight: bold;
    font-size: 15px;
    height: 40px;
  }
  .detailDialog .el-dialog__header {
    padding: 0;
    padding-left: 33px;
    font-weight: bold;
  }
  .fc-copyWeekBtn-button {
  background: #409eff !important;
  color: #fff;
  border-color: #409eff !important;
}
.fc-copyWeekBtn-button:hover {
  background: #66b1ff;
  color: #fff;
}
</style>
